import { useSyncExternalStore } from "react";

// Small global store so the debug panel toggle can live in the sidebar
// while the panel itself is rendered inside DesignResults.
let open = false;
const listeners = new Set<() => void>();

const subscribe = (cb: () => void) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

const getSnapshot = () => open;

export const setDebugPanelOpen = (next: boolean | ((prev: boolean) => boolean)) => {
  open = typeof next === "function" ? (next as (p: boolean) => boolean)(open) : next;
  listeners.forEach((l) => l());
};

export const toggleDebugPanel = () => setDebugPanelOpen((v) => !v);

export function useDebugPanel() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
